<template>
  <a-card>
    <div class="cardBody">
      <a-form>
        <div>
          <base-input :label="`Company Name`" required>
            <a-input
              placeholder="Company Name"
              v-model="formData.companyName"
            />
            <div v-if="$v.formData.companyName.$dirty" class="text-danger">
              <div class="error" v-if="!$v.formData.companyName.required">
                Field is required
              </div>
            </div>
          </base-input>
        </div>
        <div>
          <base-input :label="`Business Style`">
            <a-input placeholder="Business Style" v-model="formData.businessStyle" />
          </base-input>
        </div>
        <div>
          <base-input :label="`Company Designation`" required>
            <a-input
              placeholder="Company Designation"
              v-model="formData.companyDesignation"
            />
            <div
              v-if="$v.formData.companyDesignation.$dirty"
              class="text-danger"
            >
              <div
                class="error"
                v-if="!$v.formData.companyDesignation.required"
              >
                Field is required
              </div>
            </div>
          </base-input>
        </div>
        <div>
          <base-input :label="`TIN`" required>
            <a-input placeholder="TIN" v-model="formData.tinNumber" />
            <div v-if="showTinErrors">
              <div class="text-danger" v-if="tinErrors.alreadyInUse">
                Tin Number already in used.
              </div>
            </div>
            <div v-if="$v.formData.tinNumber.$dirty" class="text-danger">
              <div class="error" v-if="!$v.formData.tinNumber.required">
                Field is required
              </div>
              <div
                class="error"
                v-if="
                  !$v.formData.tinNumber.minLength ||
                  !$v.formData.tinNumber.maxLength
                "
              >
                Must be between 9 and 12 characters long.
              </div>
            </div>
          </base-input>
          <template>
            <b-button
              v-if="!tinValidated"
              size="sm"
              variant="primary"
              @click="verifyTin"
            >
              Verify Tin Number
            </b-button>
          </template>
        </div>
      </a-form>
    </div>
  </a-card>
</template>

<script>
import HTTPRequest from '../../../controllers/httpRequest';
import { required, maxLength, minLength } from 'vuelidate/lib/validators';

export default {
  props: {
    data: {
      type: Object,
    },
    clpSitePageSettings: { type: Object },
  },
  name: 'CompanyDetails',
  data() {
    return {
      formData: {
        companyName: null,
        companyDesignation: null,
        tinNumber: null,
        businessStyle: null
      },
      verifyTinNumberUrl: '/api/v2/clp_members/check_exist',
      showTinErrors: false,
      tinErrors: {
        required: false,
        alreadyInUse: false,
      },
      tinValidated: false,
    };
  },
  validations() {
    const validation = {
      formData: {
        companyName: { required },
        companyDesignation: { required },
        tinNumber: {
          required,
          minLength: minLength(9),
          maxLength: maxLength(12),
        },
      },
    };
    return validation;
  },
  methods: {
    async verifyTin() {
      this.$v.formData.tinNumber.$touch();
      if (!this.$v.formData.tinNumber.$invalid) {
        if (
          this.formData.tinNumber === null ||
          this.formData.tinNumber === ''
        ) {
          this.showTinErrors = true;
          this.tinErrors.required = true;
          return false;
        }
        const {
          id,
          membership_program_id: membershipProgramId,
          account_id: accountId,
        } = this.clpSitePageSettings;
        const endpointVerifyAccount = this.verifyTinNumberUrl;
        const payload = {
          account_id: accountId,
          membership_program_id: membershipProgramId,
          site_page_id: id,
          type: 'CMPTIN',
          value: `${this.formData.tinNumber}`,
        };
        const result = await HTTPRequest.getRequest(
          endpointVerifyAccount,
          payload
        );
        const { is_available: isAvailable } = result.data;
        if (isAvailable) {
          this.showTinErrors = false;
          this.tinErrors.required = false;
          this.tinErrors.alreadyInUse = false;
          this.tinValidated = true;
          this.$emit('tinVerified');
          this.$emit('verifyValue', false);
          return true;
        } else {
          this.tinErrors.required = false;
          this.showTinErrors = true;
          this.tinErrors.alreadyInUse = true;
          this.$emit('verifyValue', true);

          return false;
        }
      }
    },
  },
  async created() {
    const data = this.data;
    this.formData.companyName = data.companyName;
    this.formData.companyDesignation = data.companyDesignation;
    this.formData.tinNumber = data.tinNumber;
    this.formData.businessStyle = data.businessStyle;
  },
  watch: {
    'formData.tinNumber'(newVal) {
      if (newVal) {
        this.$emit('verifyValue', true);
        this.tinErrors.alreadyInUse = false;
        this.showTinErrors = false;
        this.tinErrors.required = false;
        this.tinValidated = false;
      }
    }
  }
};
</script>

<style></style>
